import React from 'react';
import { pathgen } from 'object-path-generator';
import { IconButton, Row, Typography } from 'seagull';
import { EditLine, TrashLine } from 'seagull/icons';
import styles from "./ServiceItem.module.scss";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const ServiceItemTestIds = pathgen('ServiceItemTestIds');
const ActionIconButton = _ref => {
  let {
    testId,
    icon,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsx(IconButton, {
    testId: testId,
    type: "button",
    size: "small",
    noPadding: true,
    skin: "transparent",
    onClick: onClick,
    children: icon
  });
};
const ServiceItem = _ref2 => {
  let {
    includedService,
    mode,
    onEdit,
    onDelete,
    testId,
    isArchived
  } = _ref2;
  function renderActionButtons() {
    switch (mode) {
      case 'editAndDelete':
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(ActionIconButton, {
            testId: ServiceItemTestIds.EditButton(includedService.serviceTemplateId || ''),
            icon: /*#__PURE__*/_jsx(EditLine, {}),
            onClick: () => onEdit(includedService)
          }), /*#__PURE__*/_jsx(ActionIconButton, {
            testId: ServiceItemTestIds.DeleteButton(includedService.serviceTemplateId || ''),
            icon: /*#__PURE__*/_jsx(TrashLine, {}),
            onClick: () => onDelete(includedService)
          })]
        });
      case 'delete':
        return /*#__PURE__*/_jsx(ActionIconButton, {
          testId: ServiceItemTestIds.DeleteButton(includedService.serviceTemplateId || ''),
          icon: /*#__PURE__*/_jsx(TrashLine, {}),
          onClick: () => onDelete(includedService)
        });
      case 'readonly':
        return null;
    }
  }
  return /*#__PURE__*/_jsxs(Row, {
    testId: testId,
    className: styles.serviceItem,
    children: [/*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.bullet
      }), /*#__PURE__*/_jsx(Typography, {
        ellipsis: true,
        variant: "paragraph1",
        testId: ServiceItemTestIds.ServiceItemName(includedService.serviceTemplateId || ''),
        children: "".concat(includedService.name).concat(isArchived ? ' (Archived)' : '')
      })]
    }), renderActionButtons()]
  });
};
export default ServiceItem;